// remates-1-3-0c (Bloque Q5, W9, 26-sep-2026): LA REVISION POR DOMINIO DEL CAMPO DE YOUTUBE DEL
// BANCO DEL PROFE, ANTES DE MANDAR NADA AL SERVIDOR.
//
// ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).
//
// ES UNA COPIA, Y A PROPOSITO. La regla vive en el servidor (`backend/services/youtube.py::
// es_de_otro_sitio`, #493: el host de la liga antes de llamar al proveedor), y el carril
// institucional no comparte codigo con el del consumidor salvo la plomeria permitida. En el
// SERVIDOR el banco la reusa sin importar nada nuevo (lee la marca `no_es_youtube` que ya devuelve
// `get_transcript`, que esta en su lista blanca); en el CLIENTE no hay plomeria que reusar, asi
// que la regla se copia aqui, al lado del profe, y `lib/youtubeDelBanco.test.js` fija que las dos
// listas de hosts son identicas y que las dos reglas dan lo mismo sobre la misma tabla de casos
// (`lib/__fixtures__/dominios_youtube.json`, calculada con la funcion del servidor).
//
// La regla, letra por letra: true SOLO si lo escrito tiene forma de liga (con esquema, o empieza
// como un dominio) y su host se deja leer y NO es de YouTube (`youtube.com` o un subdominio
// suyo, o `youtu.be`). Todo lo demas (texto suelto, un id de 11, una liga que no se deja leer)
// es false y sigue al servidor, que dira lo suyo.

// Los hosts de YouTube (los de `_HOSTS_DE_YOUTUBE` del servidor).
export const HOSTS_DE_YOUTUBE = ['youtube.com', 'youtu.be'];
// Tiene esquema (`https://`, `http://`, en mayusculas tambien).
const CON_ESQUEMA = /^[A-Za-z][A-Za-z0-9+.-]*:\/\//;
// Empieza como un dominio (`algo.tld`, con puerto opcional) seguido de fin, `/`, `?` o `#`.
const EMPIEZA_COMO_DOMINIO = /^(?:[A-Za-z0-9-]+\.)+[A-Za-z]{2,}(?::\d+)?(?:[/?#]|$)/;

function hostDe(texto) {
  try {
    return new URL(texto, 'http://base.invalid').hostname || '';
  } catch (e) {
    return '';
  }
}

/** true si lo escrito es una liga de OTRO sitio (no de YouTube). */
export function esDeOtroSitio(url) {
  if (!url || typeof url !== 'string') return false;
  const u = url.trim();
  let paraLeer;
  if (CON_ESQUEMA.test(u)) paraLeer = u;
  else if (EMPIEZA_COMO_DOMINIO.test(u)) paraLeer = `//${u}`;
  else return false;
  let host = hostDe(paraLeer).toLowerCase();
  // Un host entre corchetes (IPv6) llega con ellos en el navegador y sin ellos en el servidor.
  host = host.replace(/^\[|\]$/g, '').replace(/\.+$/, '');
  if (!host || host === 'base.invalid') return false;
  return !HOSTS_DE_YOUTUBE.some((propio) => host === propio || host.endsWith(`.${propio}`));
}
